'use client';

import { c as _c } from "react/compiler-runtime";
import * as RadixTabs from '@radix-ui/react-tabs';
import { motion } from 'framer-motion';
import { useId, useState } from 'react';
export type TabOption<T extends string = string> = {
  label: string;
  value: T;
};
export type TabsProps<T extends string = string> = {
  onChange: (value: T) => void;
  options: TabOption<T>[];
  disabled?: boolean;
  defaultValue?: T;
  /** Radix skips `onValueChange` for a trigger it believes is already active, so driving tabs from
   * code needs `value`. */
  value?: T;
};
const Tabs = t0 => {
  const $ = _c(19);
  const {
    onChange,
    options,
    disabled,
    defaultValue,
    value
  } = t0;
  const firstOptionValue = defaultValue ?? options[0].value;
  const [uncontrolled, setUncontrolled] = useState(firstOptionValue);
  const activeTab = value ?? uncontrolled;
  const id = useId();
  let t1;
  if ($[0] !== onChange) {
    t1 = next => {
      setUncontrolled(next as T);
      onChange(next as T);
    };
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChange = t1;
  const t2 = value ? undefined : firstOptionValue;
  let t3;
  if ($[2] !== activeTab || $[3] !== id || $[4] !== options) {
    let t4;
    if ($[6] !== activeTab || $[7] !== id) {
      t4 = t5 => {
        const {
          label,
          value: value_0
        } = t5;
        return <motion.div key={value_0} className="relative" layoutRoot={true} layout={true}><RadixTabs.Trigger value={value_0} className="relative text-body-2 py-1 my-1 px-1 mx-1 cursor-pointer data-[state=active]:text-accent data-[state=inactive]:text-tertiary rounded hover:data-[state=inactive]:bg-secondary transition-colors duration-100">{label}</RadixTabs.Trigger>{value_0 === activeTab && <motion.div initial={false} layoutId={id} transition={{
            duration: 0.15
          }} className="absolute -bottom-[1px] left-0 right-0 w-full h-[1px] bg-accent" />}</motion.div>;
      };
      $[6] = activeTab;
      $[7] = id;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = options.map(t4);
    $[2] = activeTab;
    $[3] = id;
    $[4] = options;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <motion.div className="relative flex border-b border-tertiary max-md:w-max max-md:min-w-full">{t3}</motion.div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== disabled || $[12] !== t4) {
    t5 = <div className="max-md:overflow-x-auto"><RadixTabs.TabsList data-is-disabled={disabled} asChild={true}>{t4}</RadixTabs.TabsList></div>;
    $[11] = disabled;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== handleChange || $[15] !== t2 || $[16] !== t5 || $[17] !== value) {
    t6 = <RadixTabs.Root onValueChange={handleChange} value={value} defaultValue={t2}>{t5}</RadixTabs.Root>;
    $[14] = handleChange;
    $[15] = t2;
    $[16] = t5;
    $[17] = value;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
export default Tabs;